import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import Step1 from '@/pages/organizations/join/step1'

export const Route = createFileRoute('/app/organizations/join/')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Step1 />
}
